import { setLocale } from 'yup'
import { ValidationMessageKeys } from './translation-keys'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { AppLang } from '@e3dc-react/shell/State/App/AppModel'
import { useEffect } from 'react'

/**
 * Sets the Yup validation messages according to the current language.
 * @param userLanguage current user language
 */
export const useSetYupLocalization = (userLanguage?: AppLang | null): void => {
  const { t } = useCustomTranslation()
  useEffect(() => {
    setLocale({
      mixed: {
        required: t(ValidationMessageKeys.required),
      },
      number: {
        min: ({ min }) => ({ key: t(ValidationMessageKeys.min), values: { min } }),
        max: ({ max }) => ({ key: t(ValidationMessageKeys.max), values: { max } }),
      },
      string: {
        min: ({ min }) => ({ key: t(ValidationMessageKeys.lengthMin), values: { min } }),
        max: ({ max }) => ({ key: t(ValidationMessageKeys.lengthMax), values: { max } }),
        email: t('validations.form.email.is-email'),
      },
    })
  }, [userLanguage, t])
}
